module.exports = require("./ta-IN.js");